import { render } from "./StackedPlotItem.vue?vue&type=template&id=2bc6b983"
import script from "./StackedPlotItem.vue?vue&type=script&lang=js"
export * from "./StackedPlotItem.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__